import { Expose } from 'class-transformer';
import { CreditsManagementTypeEnum } from '../../../../store/CreditsManagement/creditsManagementTypes';

export class CreditTypeDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: CreditsManagementTypeEnum;
}
